// Runtime half of the ONE indexability policy (src/data/indexability.json): private, personalised, temporary-live and
// grown-up routes get <meta name="robots" content="noindex,nofollow"> and no canonical. Public educational routes are left
// to useSEO() for title/description/canonical.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import POLICY from "@/data/indexability.json";

export function isNoIndexPath(pathname) {
  return POLICY.noindex_prefixes.some((p) => pathname === p || pathname.startsWith(p.endsWith("/") ? p : `${p}/`) || (p.endsWith("/") && pathname.startsWith(p)));
}

export function IndexabilityMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const noindex = isNoIndexPath(pathname);
    let el = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", "robots"); document.head.appendChild(el); }
      el.setAttribute("content", "noindex,nofollow");
      document.head.querySelector('link[rel="canonical"]')?.remove();
    } else if (el && el.getAttribute("content") === "noindex,nofollow") {
      el.remove();
    }
  }, [pathname]);
  return null;
}
